import { Controller, useFormContext } from 'react-hook-form';

import type {
  InvoiceNestedLineItemWithId} from '../InvoiceFormContext';
import {
  useInvoiceFormContext,
} from '../InvoiceFormContext';
import { currencyFormatter } from './utils';

interface PriceDisplayCellProps {
  isTrip: boolean;
  tripId: string;
  displayPrice?: number;
  lineItem: InvoiceNestedLineItemWithId;
}
export function PriceDisplayCell({
  isTrip,
  tripId,
  lineItem,
  displayPrice,
}: PriceDisplayCellProps) {
  const { control } = useFormContext();
  const { findLineItemIndex } = useInvoiceFormContext();
  const actualIndex = findLineItemIndex(lineItem);

  return (
    <Controller
      control={control}
      name={`line_items.${actualIndex}.amount_cents`}
      render={({ field }) => {
        const price = displayPrice ?? field.value;

        const priceCellValue = (
          <div
            className="text-right font-mono text-gray-800"
            data-testid={`${tripId}-trip-price`}
          >
            {currencyFormatter(price / 100)}
          </div>
        );

        if (!isTrip) {
          return priceCellValue;
        }

        return <span />;
      }}
    />
  );
}
